module.exports = __webpack_public_path__ + "3df47986fdbdddf405c67e50220f8aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/police.png
// module id = 875
// module chunks = 3